const update_sql4 = [
    'drop table if exists t_userobj;',
    'create table t_userobj(res_id, res_type, data, attr, utime, lutime, lctime,  primary key(res_id,res_type));',
];

export default update_sql4;
